import { useQuery } from "@apollo/client";
import Errors from "components/Errors";
import Page from "components/Page";
import Spinner from "components/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_PO_DELIVERIES } from "./graphql";
import SubmitDeiveryForm from "./SubmitDeiveryForm";

const PurchaseOrderDeliverPage = () => {
  const { odooCompanyId, id: poId } = useParams();

  const { loading, error, data } = useQuery(FETCH_PO_DELIVERIES, {
    variables: { poId, odooCompanyId },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const deliveries = JSON.parse(data.supplierPoDeliveries);

  const assignedDeliveries = deliveries.filter((d) => d.state !== "done");
  const assignedDelivery =
    assignedDeliveries.length === 1 ? assignedDeliveries[0] : null;

  return (
    <Page
      title={`交付产品${assignedDelivery ? ` - ${assignedDelivery.purchase_id.name}` : ""}`}
      backTo="./.."
    >
      {assignedDelivery ? (
        <SubmitDeiveryForm
          shipment={data.shipment}
          delivery={assignedDelivery}
          odooCompanyId={Number(odooCompanyId)}
        />
      ) : (
        <div>没有待交付的记录</div>
      )}
    </Page>
  );
};

export default PurchaseOrderDeliverPage;
